import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.78 6.01C9.32 6.01 8.92 5.7 8.81 5.25L8.19 2.76C8.08 2.31 7.68 2 7.22 2H6.5C5.95 2 5.74433 2.40209 5.5 3L4 7V13.01C4 13.56 4.45 14.01 5 14.01H11.5C11.96 14.01 12.36 13.7 12.47 13.25L13.97 7.25C14.13 6.62 13.65 6.01 13 6.01H9.78ZM6.59729 3H7.21923L7.83919 5.48986C8.06045 6.39025 8.86418 7.01 9.78 7.01H12.9992L11.4998 13.0075L11.4992 13.01H5V7.18133L6.43112 3.36502C6.48774 3.22687 6.53176 3.12617 6.57244 3.04658C6.58157 3.02872 6.58985 3.01328 6.59729 3Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M2 7V13C2 13.28 2.22 13.5 2.5 13.5C2.78 13.5 3 13.28 3 13V7C3 6.72 2.78 6.5 2.5 6.5C2.22 6.5 2 6.72 2 7Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }